<template>
  <Item :type="value.typename.toLowerCase()" @click="action">
    <template v-if="value.type === 'complaint'" #type>
      {{ $tc('complaint') }}
    </template>
    <template #title>
      <a href="#" @click.prevent>{{ value.title | Limit }}</a>
    </template>
    <template #datetime v-if="value.dueAt">
      <FontAwesomeIcon :icon="['fal', 'calendar-exclamation']" style="margin-right: 3px" />
      {{ $t('deadline') }}: {{ value.dueAt | Moment('DD. MMM') }}
    </template>
    <template #details>
      <div v-if="$route.name === 'dashboard' && metadata.project">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ metadata.project }}
      </div>
      <div v-if="metadata.residential">
        <FontAwesomeIcon :icon="['fal', 'house']" style="margin-right: 3px" />
        {{ metadata.residential }}
      </div>
      <div v-if="metadata.product">
        <FontAwesomeIcon :icon="['fal', 'shopping-cart']" style="margin-right: 3px" />
        {{ metadata.product }}
      </div>
      <div v-if="metadata.contact">
        <FontAwesomeIcon :icon="['fal', 'address-card']" style="margin-right: 3px" />
        {{ metadata.contact }}
      </div>
      <Avatar
        v-if="
          ($route.name === 'dashboard' && value.members.length > 1) ||
          ($route.name !== 'dashboard' && value.members.length)
        "
        class="list-item__detail--no-fade"
        :value="value.members.map(({ name, avatar }) => ({ src: avatar, name }))"
        size="nano"
      />
    </template>
  </Item>
</template>

<script>
import { Moment, Limit } from '@/filters'

import Item from '@/components/ListItem'
import Avatar from '@/components/Avatar'

const Resolver = {
  Lead: {
    contact: 'contact.name',
    project: 'project.name',
  },
  Contact: {
    contact: 'name',
  },
  Comment: {
    contact: 'author.name',
    project: 'reference.project.name',
  },
  Product: {
    product: 'name',
  },
  Residential: {
    residential: 'name',
    project: 'project.name',
  },
  ResidentialAccount: {
    residential: 'reference.name',
    project: 'reference.project.name',
  },
  Shop: {
    residential: 'reference.name',
    project: 'reference.project.name',
  },
}

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    metadata() {
      let map = Resolver[this.value.reference.onModel]
      if (!map) return {}
      return Object.fromEntries(Object.entries(map).map(([k, v]) => [k, this.$path(v, this.value.reference)]))
    },
  },
  methods: {
    action() {
      this.$bus.$emit('task', {
        id: this.value.id,
      })
    },
  },
  filters: {
    Moment,
    Limit,
  },
  components: {
    Item,
    Avatar,
  },
}
</script>

<style lang="scss">
.list-item--task {
  cursor: pointer;

  a {
    text-decoration: none;
  }
}
</style>
